module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'salary-settings-container': _vm.isInSchoolSalarySettings
    }
  }, [(_vm.isLoadingSalaryCodes) ? _c('Loader', {
    attrs: {
      "bg-color": _vm.isInSchoolSalarySettings ? '#edf0f5' : '#fff'
    }
  }) : _c('table', {
    staticClass: "do-table do-table--striped do-table--fixed"
  }, [_c('thead', [_c('th', {
    staticClass: "td-loenart"
  }, [_vm._v("Lønart")]), _vm._v(" "), _c('th', {
    staticClass: "td-tillaegsnummer"
  }, [_vm._v("Tillægsnummer")]), _vm._v(" "), _c('th', {
    staticClass: "td-navn"
  }, [_c('div', {
    staticClass: "th-text-and-button"
  }, [_vm._v("\n        Navn\n        "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.setIsCreateItemModal(true)
      }
    }
  }, [_vm._v("\n          Opret ny lønkode\n        ")])])])]), _vm._v(" "), _c('tbody', [(_vm.items.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('i', [_vm._v("Ingen oprettet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', {
      key: item.code
    }, [_c('td', {
      staticClass: "td-loenart"
    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('td', {
      staticClass: "td-tillaegsnummer"
    }, [_vm._v(_vm._s(item.tillaegsnummer ? item.tillaegsnummer : ''))]), _vm._v(" "), _c('td', {
      staticClass: "td-navn"
    }, [_vm._v(_vm._s(item.name))])])
  })], 2)]), _vm._v(" "), (_vm.isCreateItemModal) ? _c('TableCreateModal', {
    attrs: {
      "theType": 'lønkoder',
      "theEditItem": _vm.theEditItem,
      "isSubmitting": _vm.isSubmitting,
      "isDeleting": _vm.isDeleting,
      "salarySystem": _vm.salarySystem,
      "submitError": _vm.submitError
    },
    on: {
      "close": _vm.setIsCreateItemModal,
      "onSubmit": _vm.onCreate
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73b98f7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SchoolSettings/SalaryCodes.vue
// module id = 2009
// module chunks = 1